import axios from "axios";
import APINEW from "./apinew";
import APIURLMaker from "../utils/APIURLMaker";

// DELIVERY LIST DISABLED: No backend calls (re-enable by uncommenting real implementation)
const validateTC = async () => {
  return {};
};
// const validateTC = async (data) => {
//   const validationData = {
//     key: data.key,
//     confirmationCode: data.confirmationCode,
//     assignedToUserId: data.assignedToUserId || null,
//     assignedByUserId: data.assignedByUserId || null,
//     delivered: false,
//     updateTimeLocal: new Date().toISOString(),
//     updateTimeZone: "Europe/Istanbul",
//   };
//   try {
//     const url = APIURLMaker("/dcs/postDCSDeliveryConfirmation");
//     const response = await axios.post(
//       url,
//       validationData,
//       { headers: APINEW.buildHeaders() }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("TC validation error:", error);
//     throw error;
//   }
// };

// DELIVERY LIST DISABLED: No backend calls (re-enable by uncommenting real implementation)
const update = async (taskData) => {
  return { ...taskData };
};
// const update = async (taskData) => {
//   try {
//     let updatedTaskData = taskData;
//     if (taskData.delivered === false) {
//       updatedTaskData = {
//         ...taskData,
//         delivered: false,
//         deliveryMethod: null,
//         confirmationCode: null,
//         deliveryNote: "",
//       };
//     } else if (taskData.delivered === true) {
//       updatedTaskData = { ...taskData, delivered: true };
//     }
//     const url = APIURLMaker("/dcs/postDCSDeliveryUpdate");
//     const response = await axios.post(
//       url,
//       updatedTaskData,
//       { headers: APINEW.buildHeaders() }
//     );
//     console.log("API update response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error in deliveries.update:", error);
//     throw error;
//   }
// };

// DELIVERY LIST DISABLED: No backend calls until delivery feature is re-enabled (comment out the block below, uncomment this)
const getAllTasks = async () => {
  return [];
};
// const getAllTasks = async () => {
//   try {
//     const url = APIURLMaker("/dcs/getAllData");
//     const response = await axios.get(url, {
//       headers: APINEW.buildHeaders(),
//     });
//     console.log("getAllTasks response:", response.data);
//     const transformedData = response.data.map((task) => ({
//       ...task,
//       delivered: task.lastUpdate?.delivered || false,
//       deliveryMethod: task.lastUpdate?.deliveryMethod || null,
//       deliveryNote: task.lastUpdate?.deliveryNote || "",
//       deliveryTime: task.lastUpdate?.updateTimeLocal || null,
//       lastUpdate: {
//         ...task.lastUpdate,
//         delivered: task.lastUpdate?.delivered || false,
//         deliveryMethod: task.lastUpdate?.deliveryMethod || null,
//       },
//     }));
//     return transformedData;
//   } catch (error) {
//     console.error("Error getting all tasks:", error);
//     throw error;
//   }
// };

// DELIVERY LIST DISABLED: No backend calls (re-enable by uncommenting real implementation)
const assignTasks = async () => {
  return true;
};
// const assignTasks = async (taskKeys, deliveryPersonId) => {
//   try {
//     const updates = taskKeys.map((taskKey) => ({
//       key: taskKey,
//       delivered: false,
//       assignedToUserId: deliveryPersonId,
//       assignedByUserId: sessionStorage.getItem("username"),
//       updateTimeLocal: new Date().toISOString(),
//       updateTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//     }));
//     const response = await APINEW.request("/dcs/postDCSDeliveryUpdateArray", {
//       method: "POST",
//       data: updates,
//     });
//     return response;
//   } catch (error) {
//     console.error("Error assigning tasks:", error);
//     throw error;
//   }
// };

// DELIVERY LIST DISABLED: No backend calls (re-enable by uncommenting real implementation)
const unassignTasks = async () => {
  return true;
};
// const unassignTasks = async (deliveryIds) => {
//   try {
//     const updates = deliveryIds.map((key) => ({
//       key,
//       delivered: false,
//       assignedToUserId: null,
//       assignedByUserId: sessionStorage.getItem("username"),
//       updateTimeLocal: new Date().toISOString(),
//       updateTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//     }));
//     const url = APIURLMaker("/dcs/postDCSDeliveryUpdateArray");
//     const response = await axios.post(url, updates, {
//       headers: APINEW.buildHeaders(),
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error unassigning tasks:", error);
//     throw error;
//   }
// };

const deliveryapi = {
  validateTC,
  update,
  getAllTasks,
  assignTasks,
  unassignTasks,
};

export default deliveryapi;
